var _effectorFileName = "/src/page-content/pair-lessons/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const pairLessonsPage = declarePage({
  pageType: pagesPath.$url().pathname
});